import { LatLonDMS } from "./coord-dms";
import { coverageDTO } from "./coverageDTO";
import { PerformanceDTO } from "./performanceDTO";

export class NavaidFromMapModel{

  singleLevel: boolean = true;
  onlyClickedPoint: boolean = true;
  perform: string = "Coverage";
  singleAltitude : number;
  singleAltitudeMeters : number;
  minAltitude: number;
  minAltitudeMeters: number;
  maxAltitude: number;
  maxAltitudeMeters: number;
  altitudeInterval: number;
  altitudeIntervalMeters: number;
  doc: number;
  latitude: number;
  longitude: number;
  latLonDms:LatLonDMS = new LatLonDMS();
}


export class NavaidFromMapDTO{
  name: string;
  coverage: coverageDTO;
  performance: PerformanceDTO;
}
